import React from 'react'

import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import { Typography } from '@mui/material'

import { datePropType } from '~/src/Lib/PropTypes'
import DataTypeName from '~/src/UI/Shared/DataTypeName'

import Base from '../Base'
import { formatReading } from './utils'

export const ReadingFormatter = ({
  annotation,
  date = null,
  ...rest
}) => {
  const { entities } = useConnect('selectEntities')
  const { body, dataType, duration, title } = formatReading({ annotation, entities })

  return (
    <Base
      {...rest}
      title={title ? (
        <Typography variant="body1" color="textPrimary">
          <DataTypeName dataType={dataType} name={title} />
        </Typography>
      ) : null}
      body={body}
      date={duration ? <span>{duration}</span> : date}
    />
  )
}

ReadingFormatter.propTypes = {
  annotation: PropTypes.shape({
    comments: PropTypes.string,
    value: PropTypes.number,
    dataTypeKey: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
  }).isRequired,
  date: datePropType,
}

ReadingFormatter.displayName = 'Annotation/Reading'

export default React.memo(ReadingFormatter)
